import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "SubPartitionDashboardPage" */
	'pages/partition/SubPartition/SubPartitionDashboardPage'));

export default [{ component, exact: true, path: '/sub_partitions/:subPartitionId' }];